import React, { useState } from 'react';
import classnames from 'classnames';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const AbbreviationAnnotation = ({ title, children, ...props }) => {
  const [visible, setVisible] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setVisible(!visible);
  };

  const className = classnames('AbbreviationAnnotationLink', {
    'AbbreviationAnnotationLink--uncollapsed': visible,
  });

  const classNameInfo = classnames('AbbreviationAnnotation', {
    'AbbreviationAnnotation--visible': visible,
  });

  return (
    <>
      <button type="button" className={className} onClick={handleClick} {...props}>
        <span className="AbbreviationAnnotationLink__content">
          <i className="icon icon-info" />
          { children }
          <i className="icon icon-chevron-right" />
        </span>
      </button>
      <div className={classNameInfo}>
        <i className="icon icon-info" />
        <div>
          <WysiwygField
            property="schema:text"
            html={title}
          />
        </div>
      </div>
    </>
  );
};

export default AbbreviationAnnotation;
